import i18n from '@/assets/i18n/index';

// 获取当前语言
export function getCurrentLang() {
	return localStorage.getItem('appLanguage') || 'zh';
}

// 设置语言
export function setLanguage(lang) {
	localStorage.setItem('appLanguage', lang);
}

// 获取翻译文本
export function t(key, params = {}) {
	const currentLang = getCurrentLang();
	const keys = key.split('.');

	// 从i18n配置中获取对应的翻译
	let translation = i18n[currentLang];
	for (const k of keys) {
		if (!translation || !translation[k]) return key; // 如果找不到翻译，返回原始key
		translation = translation[k];
	}

	// 替换参数
	if (typeof translation === 'string') {
		return translation.replace(/{(\w+)}/g, (match, p1) => {
			return params[p1] !== undefined ? params[p1] : match;
		});
	}

	return translation;
}

// 切换到指定语言
export function switchLanguage(lang) {
	const supportedLangs = ['zh', 'en', 'vi'];
	if (supportedLangs.includes(lang)) {
		setLanguage(lang);
		return lang;
	}
	return getCurrentLang();
}

// 获取当前所有支持的语言
export function getSupportedLanguages() {
	return [
		{ code: 'zh', name: '中文', icon: '🇨🇳' },
		{ code: 'en', name: 'English', icon: '🇺🇸' },
		{ code: 'vi', name: 'Tiếng Việt', icon: '🇻🇳' },
	];
}
